import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import MemberTable from "./components/MemberTable";
import AddIcon from "../../components/common/AddIcon";
import SimpleModal from "../../components/common/SimpleModal";
import MemberForm from "./components/form/MemberForm";
import { toggleMemberModal } from "../management/redux/managementSlice";
import { useMemberQuery } from "../../graphql/apollo/query-hooks";

const Member = () => {
  const dispatch = useDispatch();
  const { isOpenMemberModal } = useSelector((state) => state.management);
  const { memberList, loading } = useMemberQuery();

  const handleToggle = () => dispatch(toggleMemberModal());

  return (
    <>
      <SimpleModal
        show={isOpenMemberModal}
        handleClose={handleToggle}
        title="ເພີ່ມຂໍ້ມູນລູກຄ້າ"
        size="lg"
      >
        <MemberForm handleClose={handleToggle} />
      </SimpleModal>

      <Card>
        <Card.Header>
          <Card.Title>
            <h3 className="p-1">ຈັດການຂໍ້ມູນສະມາຊິກ</h3>
          </Card.Title>
          <AddIcon onClick={handleToggle} />
        </Card.Header>
        <Card.Body>
          <MemberTable data={memberList} loading={loading} />
        </Card.Body>
      </Card>
    </>
  );
};

export default Member;
